<template lang="pug">
  div
    app-sublayer-header Отпуск/Больничный
    app-empty-list(v-if="holidays.length == 0") Список пуст
    app-group-animation
      app-group-item(v-for="h in holidays" :key="h.id" cols="12")
        app-card(@click.native="moveHoliday(h)")
          app-card-body
            app-card-title с {{ $_shortFormatRu(h.startDate) }} по {{ $_shortFormatRu(h.endDate) }}
            app-card-caption {{ h.holidayType ? h.holidayType.title : 'Не определен' }}

    app-dialog(v-model="dialog.holidayControl" header="Управление отпуском/больничным" :items="holidayItems")
    holidayAdd(v-model="dialog.holidayEdit" ref="holidayEdit" :holiday="holiday")
    holidayDel(v-model="dialog.holidayDel" ref="holidayDel" :holiday="holiday")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { $_app_moment } from "@/common/AppMoment.js"
import HolidayAdd from "./HolidayAdd"
import HolidayDel from "./HolidayDel"

import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [ $_app_moment ],

  components: {
    HolidayAdd, HolidayDel
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge']),
    ...mapGetters('judgeReestr', ['holidayTypes']),

    holidays () {
      return this.sortHoliday()
    },

    holidayItems () {
      return [
        { title: 'Редактировать', icon: 'edit', action: () => this.$refs.holidayEdit.show() }, 
        { title: 'Удалить', icon: 'delete', action: () => this.$refs.holidayDel.show() }
      ]
    },
  },
  methods: {
    sortHoliday () {
      return this.currentJudge.holiday.sort((a, b) => !b.startDate || b.startDate.localeCompare(a.startDate) || b.id - a.id)
    },

    moveHoliday (h) {
      if (this.currentJudge.archive) return null
      this.holiday = h
      this.dialog.holidayControl = true
    }
  },
  
  data () {
    return {
      dialog: {
        holidayControl: false,
        holidayEdit: false,
        holidayDel: false,    
      },
      holiday: {}
    }
  },
}
</script>